import moment from 'moment';
import { Button } from 'semantic-ui-react';
import weddingRequestService from '../../../services/api/weddingRequestService';
import Swal from 'sweetalert2';
import {
  useRecaptchaToken,
  isCaptchaRequired,
  RECAPTCHA_SECURITY_ERROR,
} from 'src/components/helpers/recaptchaUtils';
import { chPerm } from 'src/components/helpers';

const PendingWeddingRequestGroupRow = (props) => {
  const { request, set_loading, loading, getInfo, group_id } = props;

  const { FemaleGuest, MaleGuest, maleLeaderApproved, femaleLeaderApproved } = request;
  const getCaptchaToken = useRecaptchaToken('wedding_leader_check');

  const sendRequest = async (id, reason) => {
    set_loading(true);

    const captchaRequired = isCaptchaRequired() && !chPerm(['solicitudes_matrimonio']);
    const captcha = await getCaptchaToken({ skip: !captchaRequired });
    if (captchaRequired && !captcha) {
      set_loading(false);
      Swal.fire(RECAPTCHA_SECURITY_ERROR);
      return;
    }

    const body = {
      id,
      male_guest_id: MaleGuest?.id,
      female_guest_id: FemaleGuest?.id,
      ...(captchaRequired ? { captcha } : {}),
    };
    if (maleLeaderApproved === null) {
      body.maleLeaderApproved = reason;
      body.male_group_id = group_id;
    }
    if (femaleLeaderApproved === null) {
      body.femaleLeaderApproved = reason;
      body.female_group_id = group_id;
    }

    weddingRequestService
      .WeddingRequestsLeaderChecks(body)
      .then((response) => {
        if (response.data.success) {
          set_loading(false);
          getInfo();
        } else {
          set_loading(null);
          if (response.data?.message) Swal.fire(response.data.message);
        }
      })
      .catch((error) => {
        set_loading(false);
        if (error.response?.data?.message) Swal.fire(error.response.data.message);
      });
  };

  const rejectWeddingRequestLeader = async () => {
    const { value: text } = await Swal.fire({
      title: `¿Seguro que desea no aprobar la solicitud de matrimonio?`,
      text: `Escribe la razón para no aprobar la solicitud de matrimonio de ${MaleGuest?.name} y ${FemaleGuest?.name}`,
      input: 'text',
      inputPlaceholder: 'Escribe la razón',
      inputAttributes: {
        'aria-label': 'razon',
      },
      showCancelButton: true,
    });

    if (text) {
      sendRequest(request.id, text);
    }
  };

  const acceptWeddingRequestLeader = async () => {
    Swal.fire({
      title: 'Enviar aprobación',
      text: `Desea aprobar la solicitud de matrimonio de ${MaleGuest?.name} y ${FemaleGuest?.name}`,
      showCancelButton: true,
      confirmButtonText: 'Si, aprobar',
      cancelButtonText: 'Volver',
    }).then((result) => {
      if (result.value) {
        sendRequest(request.id, 'Aprobado');
      }
    });
  };

  return (
    <tr>
      <td className="date">
        <p style={{ margin: '0' }}>
          {moment.tz(request?.createdAt, 'America/Bogota').format('DD-MM-YYYY')}
        </p>
      </td>
      <td>
        <p style={{ margin: '0' }}>{MaleGuest?.phone}</p>
      </td>
      <td>
        <p style={{ margin: '0' }}>
          <span>{MaleGuest?.name}</span> <span>{MaleGuest?.lastName}</span>
        </p>
      </td>

      <td>
        <p style={{ margin: '0' }}>{FemaleGuest?.phone}</p>
      </td>
      <td>
        <p style={{ margin: '0' }}>
          <span>{FemaleGuest?.name}</span> <span>{FemaleGuest?.lastName}</span>
        </p>
      </td>
      <td>
        <Button onClick={acceptWeddingRequestLeader} disabled={loading}>
          Aprobar
        </Button>
      </td>
      <td>
        <Button onClick={rejectWeddingRequestLeader} disabled={loading}>
          Rechazar
        </Button>
      </td>
    </tr>
  );
};

export default PendingWeddingRequestGroupRow;
